<template>
    <div class="wxPay">
        <div class="goback" @click="goback">
            <span class="el-icon-arrow-left"></span>
            <p>返回</p>
        </div>
        <div class="order-container">
            <div class="desc">
                <h3>订单编号：{{ orderId }}</h3>
                <h4>
                    <i>实付金额：</i>
                    <span>￥{{payAmount}}</span>
                </h4>
            </div>
            <div class="qrcode-container">
                <img class="icon" src="../../assets/images/buy/weixin_icon.png" alt="">
                <div class="qrcode" ref="qrCodeUrl"></div>
            </div>
            <div class="tip">
                <img src="../../assets/images/buy/saomiao.png" alt="">
                <p>请使用微信扫描二维码完成支付</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import QRCode from "qrcodejs2";
// import { orderWxSuccess } from "@http/order/index";
import { GetUrlParam } from "@/utils/filter";
import { GetRequest } from '@/utils/utils'
import request from "@/request";
import { paymentRetentionPopStatus } from "@http/overview/index";
import { getAdBannerApi } from "@http/website/index"
export default {
    components: {
    },
    data() {
        return {
            timer: "",
            value: 0,
            orderId:'',
            payAmount:'',
        };
    },
    computed: {
        ...mapGetters([]),
        ...mapState({
            navBarMaskShow: (state) => state.routerInfo.navBarMaskShow,
            payLeave: (state) => state.routerInfo.payLeave,
        }),
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
    },
    watch: {},
    methods: {
        ...mapMutations('routerInfo', ['setNavBarMaskShow', 'setPayLeave']),
        creatQrCode() {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: decodeURIComponent(GetUrlParam("codeUrl")),
                width: 210,
                height: 210,
                margin: 0, 
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
            });
        },
        async orderWxSuccess() {
            let that = this;
            let orderId = GetUrlParam("orderId");
            request({
                method: "get",
                url: "/order/wxSuccess",
                params: { orderId },
            })
                .then((res) => {
                    if (res.data.code == 200) {
                        this.$msg(res.data.message, "success");
                        this.$router.push({
                            path: "/userAccount/buy/paySuccess",
                            query: {
                                orderId
                            }
                        });
                    }
                })
                .catch((e) => {
                    that.$msg(e.message, "error");

                    console.log(e);
                }); 
        },
        goback(){
            zhuge.track('用户中心_微信支付_返回', () => {
                this.$router.go(-1);
            })
            
        }
    },
    async created() {
        console.log('wxPay created')
        this.$nextTick(() => {
            this.creatQrCode();
        });
        try {
            let { payLeave } = await getAdBannerApi({
                locations: 10
            })
            this.setPayLeave(payLeave)
        } catch (e) {
            console.log(e)
        }
        this.timer = setInterval(this.orderWxSuccess, 2000);
        this.orderId=this.$route.query.orderId;
        this.payAmount=this.$route.query.payAmount;
        // 200~2000元之间需要优惠弹窗
        // 先注释以防以后运营加回来
        // if (GetRequest().buyCount && GetRequest().suiteId) {
        //     let buyCount = parseFloat(GetRequest().buyCount);
        //     if (buyCount !== NaN) {
        //         // 判断是否需要优惠弹窗
        //         paymentRetentionPopStatus({
        //             suiteId: GetRequest().suiteId,
        //             buyCount: buyCount
        //         }).then(({ popStatus, seqNo, discount }) => {
        //             this.seqNo = seqNo
        //             this.discount = discount
        //             if (popStatus === 1) {
        //                 this.setNavBarMaskShow(true)
        //                 window.history.pushState(null, null, window.location.href); // 防止页面刷新
        //             } else {
        //                 this.setNavBarMaskShow(false)
        //             }
        //         })
        //     }
        // }
        this.setNavBarMaskShow(true)
        
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.setNavBarMaskShow(false)
        // 关闭支付挽留弹窗
        this.$TsaPayRetainDialog.hide()
    },
};
</script>

<style scoped lang="less">
.wxPay {
    width: 750px;
    margin: 0 auto;
    .goback {
        width: 104px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #E8E9EB;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-bottom: 13px;
        &:hover {
            span {
                color: #2468F2;
            }
            p {
                color: #2468F2;
            }
        }
        span {
            color: #151B26;
            font-size: 14px;
            margin-right: 6px;
        }
        p {
            font-size: 14px;
            color: #151B26;
        }
    }
    .order-container {
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        padding-top: 40px;
        padding-bottom: 69px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        .desc {
            width: 240px;
            padding-left: 7px;
            h3 {
                font-weight: bold;
                font-size: 16px;
                color: #151B26;
                margin-bottom: 16px;
            }
            h4 {
                display: flex;
                align-items: center;
                margin-bottom: 44px;
                i {
                    font-weight: bold;
                    font-size: 16px;
                    color: #151B26;
                    font-style: normal;
                    flex-shrink: 0;
                }
                span {
                    font-weight: bold;
                    font-size: 24px;
                    color: #F33D3D;
                    margin-left: 10px;
                }
            }
        }
        
        .qrcode-container {
            width: 240px;
            height: 240px;
            border: 1px solid #EDEDED;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 16px;
            position: relative;
            .icon {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 50px;
                height: 50px;
            }
        }
        .tip {
            display: flex;
            align-items: center;
            img {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }
            p {
                font-size: 16px;
                color: #6B748F;
            }
        }
    }
}

</style>
